<mat-form-field appearance="outline" [class.hidden]="prefilteredCount === 0">
  <mat-label>{{label}}</mat-label>
  <input matInput [formControl]="searchControl"/>
  <button matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
@if (contentTemplate) {
  @if (postfilteredCount === 0) {
    <p class="no-results">{{ isFilterApplied ? 'No results found' : 'No results available' }}</p>
  }
    <ng-container *ngTemplateOutlet="contentTemplate; context: {
        $implicit: filteredData$,
        prefilteredCount: prefilteredCount,
        postfilteredCount: postfilteredCount,
        isFilterApplied: isFilterApplied
    }"></ng-container>
}